import React, { Fragment } from 'react'
import TutorialCard from './TutorialCard'
import { Row, Col } from 'react-bootstrap'

export default function LicensedTutorials({ handleShowTutorial }) {

  return (
    <Fragment>
      <Row className='mb-3'>
        <Col>
          <TutorialCard 
            icon={<i className="fas fa-laptop-medical fa-sm text-light"></i>}
            title='Telehealth'
            tutorials={[
              // { id: 1, link: '', title: 'How to send a care plan (NEED VID)' },
              { id: 2, link: 'https://www.youtube.com/embed/9qXm57pJuZc', title: 'How to start a video telehealth' },
              { id: 3, link: 'https://www.youtube.com/embed/A20EF280Ngg', title: 'How to send a message through telehealth' },
            ]}
            showTutorial={handleShowTutorial}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <TutorialCard 
            icon={<i className="far fa-comment-dots fa-sm text-light" aria-hidden="true"></i>}
            title='Messages'
            tutorials={[
              { id: 4, link: 'https://www.youtube.com/embed/wE3CVpj9sIk', title: 'How to send a patient messsage' },
            ]}
            showTutorial={handleShowTutorial}
          />
        </Col>
      </Row>
    </Fragment>
  )
}